import React from 'react';
import { Helmet } from 'react-helmet-async';
import RegisterFormComponent from '../components/RegisterForm';

const Register = () => {
    return (
        <>
            <Helmet>
                <title>Register - Community Plus Care Services</title>
                <meta name="description" content="Register with Community Plus Care Services to access our NDIS support and care programs." />
            </Helmet>
            <RegisterFormComponent />
        </>
    );
};

export default Register;
